import React from 'react';
import '../Styles/UshasVas.css';

const UshasVas = () => {
  const handleClick = () => {
    window.open('https://ushasvas.shantigroup.in/', '_blank', 'noopener noreferrer');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <section
      className="ushasvas-section"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="link"
      tabIndex={0}
      aria-label="Visit UshasVas — Solar Capacity Sizing and Feasibility Tool"
    >
      {/* Starfield atmosphere */}
      <div className="uv-atmosphere" aria-hidden="true"></div>

      {/* Sun glow */}
      <div className="uv-sun-glow" aria-hidden="true"></div>

      {/* Animated solar rays */}
      <div className="uv-rays" aria-hidden="true">
        {[...Array(16)].map((_, i) => (
          <div key={i} className="uv-ray" style={{ '--i': i }}></div>
        ))}
      </div>

      {/* Main content */}
      <div className="uv-content">
        <div className="uv-badge">
          <span className="uv-badge-dot"></span>
          Open Source
        </div>

        <div className="uv-brand-row">
          <div className="uv-sun-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="5" fill="currentColor" />
              <line x1="12" y1="1" x2="12" y2="4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="12" y1="20" x2="12" y2="23" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="1" y1="12" x2="4" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="20" y1="12" x2="23" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="4.22" y1="4.22" x2="6.34" y2="6.34" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="17.66" y1="17.66" x2="19.78" y2="19.78" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="19.78" y1="4.22" x2="17.66" y2="6.34" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
              <line x1="6.34" y1="17.66" x2="4.22" y2="19.78" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
            </svg>
          </div>
          <h2 className="uv-title">UshasVas</h2>
        </div>

        <p className="uv-subtitle">
          Our open source application will help you with<br />
          <strong>solar capacity sizing and feasibility</strong>
        </p>

        <div className="uv-features">
          <div className="uv-feature-pill">
            <span className="uv-pill-icon">⚡</span>
            Capacity Sizing
          </div>
          <div className="uv-feature-pill">
            <svg className="uv-pill-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="15" height="15" aria-hidden="true">
              <rect x="3" y="12" width="4" height="9" rx="1" fill="currentColor"/>
              <rect x="10" y="7" width="4" height="14" rx="1" fill="currentColor"/>
              <rect x="17" y="3" width="4" height="18" rx="1" fill="currentColor"/>
            </svg>
            Feasibility Analysis
          </div>
          <div className="uv-feature-pill">
            <span className="uv-pill-icon">☀️</span>
            Solar Planning
          </div>
        </div>

        <button className="uv-cta-btn" onClick={(e) => { e.stopPropagation(); handleClick(); }}>
          <span>Launch App</span>
          <svg viewBox="0 0 24 24" fill="none" width="18" height="18" aria-hidden="true">
            <path d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
              stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

        <p className="uv-click-hint">Click anywhere to explore UshasVas →</p>
      </div>

      {/* Horizon glow line */}
      <div className="uv-horizon" aria-hidden="true"></div>
    </section>
  );
};

export default UshasVas;
